export default{
    myCollection:{
        Notification:{
           
        },
        Message:{
            delete:{
                success:'删除成功！',
            },
        },
        Alert:{
            error:{
                title:'提示',
                text:'数据请求失败，请重试',
                buttonText:'确定',
            }
        },
        Button:{
            
        },
        Placeholder:{
            text1:'请输入商品名称搜索',
            text2:'请输入店铺名称搜索'
        },
        Validate:{

        },
        Description:{
            noData:'暂无数据',
            more:'查看更多',
            module1:{
                title:'商品',
                item:{
                    text1:'累计销量：',
                    text2:'笔'
                },
            },
            module2:{
                title:'店铺',
                item:{
                    text1:'联系人：',
                    text2:'手机号：',
                    text3:'所在地：',
                    text4: '邮箱：',
                    button1:'进入店铺',
                    button2:'取消关注',
                },
            },
            module3:{
                title:'新品推荐'
            }
        },
        Checkbox:{
            
        },
        Table:{

        },
        ValidData:{
            
        },
        InvalidData:{
            
        },
        Confirm:{
            cancel:'取消',
            confirm:'确认',
            title:'删除提示',
            text:'是否删除该收藏？',
        }
    }
    
}